import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ListadoPageable, Emisor } from '../../interfaces/domiciliacion';

@Injectable({
  providedIn: 'root'
})
export class DomiciliacionService {

  private url = environment.apiUrl + '/';

  httpOptionsJson = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }),
    withCredentials: true,
  };

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    }),
    withCredentials: true,
  };

  constructor(private http: HttpClient) { }

  getDomiciliacionPageable(page: number, size: number): Observable<ListadoPageable> {
    return this.http.get<ListadoPageable>(this.url + `api/domiciliacion/listado?page=${page}&size=${size}`,  this.httpOptions);
  }

  crearFechaDomiciliacion(fecha: string): Observable<any> {
    let body = {
      algo: "algo"
    }
    return this.http.post<any>(this.url + `api/domiciliacion?fechaDomiciliacion=${fecha}`, body,this.httpOptionsJson);
  }

  crearArancel(domiciliacionId: number, arancel: boolean): Observable<any> {
    let body = {
      algo: "algo"
    }
    return this.http.put<any>(this.url + `api/domiciliacion/arancel?domiciliacionDetalleId=${domiciliacionId}&arancel=${arancel}`, body,  this.httpOptionsJson);
  }

  getDomiciliacionFiltrable(domiciliacionId: number, ape: string, status: string, tipoId: string, grupoId: string, page: number, size: number): Observable<ListadoPageable> {
    return this.http.get<ListadoPageable>(this.url + `api/domiciliacion/listado/detalle?domiciliacionId=${domiciliacionId}&apenom=${ape}&estado=${status}&tipoId=${tipoId}&grupoId=${grupoId}&page=${page}&size=${size}`,  this.httpOptions);
  }

  getEmisores(): Observable<Emisor[]> {
    return this.http.get<Emisor[]>(this.url + `api/domiciliaciondatos`,  this.httpOptions);
  }

}
